import { createReducer } from "@reduxjs/toolkit";
import { addNavigation, removeNavigation, resetAll, resetSingleNavigationPath, } from "../actions";
const initialState = {};
export const configurationNavigationPathsReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(addNavigation, (state, action) => {
        const { previousPath, nextPath } = action.payload;
        state[previousPath] = nextPath;
    })
        .addCase(removeNavigation, (state, action) => {
        const { previousPath, nextPath } = action.payload;
        if (state[previousPath] === nextPath) {
            delete state[previousPath];
        }
    })
        .addCase(resetSingleNavigationPath, (state, action) => {
        const { resetPath } = action.payload;
        // delete all sub paths
        for (const key in state) {
            if (key.startsWith(resetPath)) {
                delete state[key];
            }
        }
    })
        .addCase(resetAll, () => {
        return initialState;
    });
});
//# sourceMappingURL=configurationNavigationPathsReducer.js.map